import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as auth from "modules/Auth/_redux/authRedux";
import JWTService from "@core/auth/JWTService";
import SocialBar from "./parts/SocialBar";
import "./Login.css";
//import { toast } from "react-toastify";
//import PhoneField from "./parts/PhoneField";

function Login(props) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  function loginLocal(e) {
    e.preventDefault();
    setLoading(true);
    JWTService.signInWithCredential(form.email, form.password)
      .then((userInformation) => {
        // User information moved to persist state via redux.
        props.login(userInformation.user);
        props.setBalance(userInformation.balance);

        const pageToRedirectAfterLogin = localStorage.getItem(
          "pageToRedirectAfterLogin"
        );

        let redirectRoute = "/";
        if (userInformation.user.role == "temporary") {
          redirectRoute = "/otp";
        }

        if (pageToRedirectAfterLogin) {
          redirectRoute = pageToRedirectAfterLogin;
        }

        return redirectRoute;
      })
      .then((redirectRoute) => {
        // Redirection after login
        props.history.push(redirectRoute);
        localStorage.removeItem("pageToRedirectAfterLogin");
      })
      .catch((err) => {
        // If user credential error show message
        //toast.error(err.response.data.message);
        setLoading(false);
      });
  }

  function handleChange(event) {
    event.persist();
    setForm((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  }

  // function handleChangePhone(event) {
  //   setForm((prevState) => ({
  //     ...prevState,
  //     [event.target.name]: event.target.value,
  //   }));
  // }

  return (
    <div className="auth-split">
      <div className="auth-split__brand">
        <div className="auth-split__brand-decor" />
        <div className="auth-split__brand-decor auth-split__brand-decor--2" />

        <div className="auth-split__headline">
          <h2>Alıcı ile satıcı burada buluşur.</h2>
          <p>
            Aradığını yaz, satıcılar sana gelsin. Ürününü koy, alıcılar seni
            bulsun. Hesabına giriş yap, ilanlarını yönet.
          </p>
        </div>

        <ul className="auth-split__points">
          <li>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
            Aradığını tarif et, satıcılar sana ulaşsın
          </li>
          <li>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
            Ürününü dakikalar içinde yayınla
          </li>
          <li>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
            Mesajlaş, anlaş, güvenle tamamla
          </li>
        </ul>
      </div>

      <div className="auth-split__form">
        <div className="auth-split__card">
          <div className="auth-split__logo">
            <Link to={"./"}>
              <img src={require("images/alicilar-logo.png")} alt="" />
            </Link>
          </div>
          <div id="login">
            <form className="dez-form">
              <h5 className="form-title m-t0">Giriş</h5>
              <div className="dez-separator-outer m-b5">
                <div className="dez-separator bg-primary style-liner" />
              </div>
              {/*<p>Enter your e-mail address and your password. </p>*/}

                      <div className="form-group">
                        <input
                          name="email"
                          autoFocus
                          required
                          className="form-control "
                          value={form.email}
                          onChange={handleChange}
                          placeholder="E-Posta"
                          type="email"
                        />
                      </div>

                      <div className="form-group">
                        <input
                          name="password"
                          required=""
                          className="form-control "
                          value={form.password}
                          onChange={handleChange}
                          placeholder="Şifre"
                          type="password"
                        />
                      </div>

                      <div className="form-group text-left">
                        <div className="d-flex justify-content-between align-items-center">
                          <button
                            className="site-button dz-xs-flex m-r5"
                            disabled={
                              loading ||
                              form.email === "" ||
                              form.password === ""
                            }
                            onClick={loginLocal}
                          >
                            {loading ? "Yükleniyor.." : "Giriş Yap"}
                          </button>
                          <span className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              checked
                              id="check1"
                              name="example1"
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="check1"
                            >
                              Beni Hatırla
                            </label>
                          </span>
                        </div>
                        <div className="d-flex flex-row justify-content-between">
                          <Link
                            data-toggle="tab"
                            to="/register"
                            className="forget-pass m-l5"
                          >
                            <i className="fa fa-sign-in" /> Üye Ol
                          </Link>
                          <Link
                            data-toggle="tab"
                            to="/forgotPassword"
                            className="forget-pass m-l5"
                          >
                            <i className="fa fa-unlock-alt" /> Şifremi Unuttum
                          </Link>
                        </div>
                      </div>
              <SocialBar />
            </form>
          </div>
          <div className="auth-split__footer">
            © Copyright by{" "}
            <Link to={"/"}>
              Alıcılar Bilgi Teknolojileri Pazarlama ve Ticaret A.Ş.
            </Link>{" "}
            All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, auth.actions)(withRouter(Login));
